import useUserHasPermission from "@/shared/hooks/use-useris.hook";

const useUserHelp = () => {
  const INSTANCES = useUserHasPermission();

  return {
    ...INSTANCES
  };
};

export default useUserHelp;
